import { Input, Output, EventEmitter, SimpleChanges, Injectable, Component } from '@angular/core';
import { TreeViewDataBase } from '../models/tree-view-data-base';
import { CheckboxItem } from '../models/checkbox-treeview-item';

import { ParamData } from '../models/param-data';
import { CheckboxTreeviewComponent } from './checkbox-treeview/checkbox-treeview.component';
import { CheckboxTreeviewEventParser } from '../models/checkbox-treeview-event-parser';

@Component({
    template: '',
    standalone: false
})
export abstract class TreeviewBase {

    @Input() paramData: ParamData;
    @Input() treeViewData: TreeViewDataBase;
    @Output() updatedParam = new EventEmitter();

    /**
     * Tree-view default config
     */
    treeviewConfig = {
        hasAllCheckBox: true,
        maxHeight: 350
    };

    /**
     * Uppdatering av Input kräver manuell hantering
    * @param changes
    */
    ngOnChanges(changes: SimpleChanges) {
        if (changes['paramData']) {
            if (this.treeViewData) {
                this.treeViewData.updatingParam = true; //Stäng av automatisk uppdatering av rapport via selectedChange under tiden komponenten uppdateras med data uppifrån.
                let collapseFirstLevel = false;
                if (this.treeViewData["items"] != null && this.treeViewData["items"].length > 0) collapseFirstLevel = this.treeViewData["items"][0].collapsed;
                this.treeViewData.setItems(this.paramData, collapseFirstLevel);
                setTimeout(() => {
                    this.treeViewData.updatingParam = false; //Återställ uppdateringar uppåt.
                });
            }
        }
    }

    /**
     * Tree-view change. Triggar uppdatering uppåt, om inte komponenten håller på att uppdateras uppifrån.
     * (Lite knasigt, men tredjepartskomponenten triggar en extern uppdatering när den själv uppdateras programmatiskt).
     * @param items Direkt referens till datan
     */
    public onSelectedChange(items: CheckboxItem[]) {
        let dataCopy = [...this.paramData.data]; //Kopia, för ChangeDetection
        this.handleCheck(dataCopy, items);

        if (this.stringArraysAreIdentical(this.paramData.data, dataCopy))
            return; //Inga ändringar, uppdatera inte uppåt. Detta behöver kontrolleras eftersom ett flikbyte anses vara en 'ändring' i komponenten.

        if (this.treeViewData.updatingParam)
            return; //Uppdatering innifrån komponenten, uppdatera inte uppåt.

        this.paramData.data = dataCopy; //Uppdatera
        this.updatedParam.emit(this.paramData); //Skicka uppåt
    }

    /**
     * Kontrollera rekursivt om någon checkbox har klickats ur eller i, i jämförelse med paramData
     * @param paramData
     * @param treeItems
     * @param hasChanges
     */
    private handleCheck(paramData: string[], treeItems: CheckboxItem[]): void {
        treeItems.forEach((item) => {
            if (item.children) {
                //Hantera bara de yttersta löven på trädet. Gå rekursivt.
                this.handleCheck(paramData, item.children);
                return;
            }
            //Vi är längst ut! Kontrollera om det skett några ändringar på treeView mot paramData
            let matchIndex = -1;
            paramData.forEach((data, index) => {
                if (data.toString() === item.value) {
                    matchIndex = index;
                }
            });
            if (matchIndex === -1 && item.checked) {
                //Detta är en ny iklickad checkbox
                paramData.push(item.value); //Lägg till i paramData
            }
            if (matchIndex !== -1 && !item.checked) {
                //Detta är en avklickad checkbox
                paramData.splice(matchIndex, 1); //Ta bort från paramData
            }
        });
    }

    private stringArraysAreIdentical(a1: string[], a2: string[]): boolean {
        if (a1.length === a2.length) {
            let missing = a1.filter(item => a2.indexOf(item) < 0);
            return missing.length === 0;
        }
        return false;
    }

}

/**
 * Vi behöver hela TreeViewComponenten för att kontrollera tillägg och ändringar i uppdateringsprocessen
 */
@Injectable()
export class GetWholeTreeviewEventParser extends CheckboxTreeviewEventParser {
    override getSelectedChange(component: CheckboxTreeviewComponent): any[] {
        return component.treeviewItems;
    }
}
